import { ButtonLink } from '@/components/Button'
import { Image } from '@/components/Image'
import { BodyP } from '@/components/Typography'
import type { BuilderImage } from '@/models/BuilderImage'

import { MediaProductGuideContainer, MediaProductGuideSummary } from './styles'

interface MediaProductGuideButton {
  text: string
  url: string
}

export interface MediaProductGuideProps {
  image?: BuilderImage
  shortDescription?: string
  button?: MediaProductGuideButton
}

const MediaProductGuide = ({ image, shortDescription, button }: MediaProductGuideProps) => (
  <li>
    <MediaProductGuideContainer>
      {image && (
        <div>
          <Image
            source={image.url}
            alt={image.alt}
            aria-hidden={image['aria-hidden']}
            width={280}
            height={111}
          />
        </div>
      )}
      <MediaProductGuideSummary>
        {shortDescription && <BodyP tag="div" html={shortDescription} />}
        {button && (
          <ButtonLink source={button.url} modifier="solid" rounded>
            {button.text}
          </ButtonLink>
        )}
      </MediaProductGuideSummary>
    </MediaProductGuideContainer>
  </li>
)

export default MediaProductGuide
